<template>
  <div class="page-container">
    <md-app md-waterfall md-mode="fixed">
      <md-app-drawer />
      <md-app-toolbar class="md-small md-dense md-accent">
        <div class="md-toolbar-row">
          <div class="md-toolbar-section-start">
            <span class="md-title">TSV Eningen 1848 Trainer App</span>
          </div>
        </div>

        <div class="md-toolbar-row">
          <md-tabs class="md-accent">
            <md-tab
              v-on:click="handleCoach"
              id="tab-home"
              md-label="Abrechnung melden"
            ></md-tab>
            <md-tab
              v-on:click="handleHistory"
              id="tab-history"
              md-label="Verlauf"
            ></md-tab>
            <md-tab
              v-on:click="handleVersion"
              id="tab-version"
              md-label="Version"
            ></md-tab>
          </md-tabs>
        </div>
      </md-app-toolbar>

      <md-app-content v-if="coachMode">
        <div class="md-small">
          <md-field>
            <label>Name</label>
            <md-input v-model="coach"></md-input>
          </md-field>

          <md-field>
            <label>PIN</label>
            <md-input v-model="pin" id="inputPIN" type="password"></md-input>
          </md-field>

          <div class="md-layout-item">
            <md-field>
              <label for="title"
                >Abrechnungsart (Training, Spieltag oder Schiedsrichter)</label
              >
              <md-select v-model="titel" name="titel" id="titel" md-dense>
                <md-option value="Training">Training</md-option>
                <md-option value="Spieltag">Spieltag</md-option>
                <md-option value="Schiedsrichter">Schiedsrichter</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-field>
              <label for="country">Jugend</label>
              <md-select v-model="team" name="jugend" id="jugend" md-dense>
                <md-option value="B-Junioren">B-Junioren</md-option>
                <md-option value="C-Junioren">C-Junioren</md-option>
                <md-option value="D-Junioren">D-Junioren</md-option>
                <md-option value="E-Junioren">E-Junioren</md-option>
                <md-option value="F-Junioren">F-Junioren</md-option>
                <md-option value="Bambinis">Bambinis</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-checkbox
              v-model="responsible"
              value="1"
              :disabled="isResponsibleDisabed"
            >
              <label>verantwortlich</label>
            </md-checkbox>
          </div>

          <md-datepicker
            v-model="date"
            md-immediately
            class="{ 'md-required': field.required }"
          >
            <label>Datum</label>
          </md-datepicker>

          <md-button
            class="md-raised md-accent"
            :disabled="!isSendEnabled"
            v-on:click="handleSend"
            >Senden</md-button
          >

          <md-snackbar :md-active.sync="showSnackbar" :md-duration="2000">
            <span>{{ snackBarText }}</span>
          </md-snackbar>
        </div>
      </md-app-content>
      <md-app-content v-if="historyMode">
        <div v-if="coach.length != 0">
          <h2 class="md-title">Trainingseinheiten für {{ coach }}</h2>
          Nur die aktuellsten 5 Trainingseinheiten werden angezeigt.<br />
          <md-table v-model="trainingItems">
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              style="line-heigt: 10px"
            >
              <md-table-cell md-label="Datum" md-string>{{
                m(item.Date).format("L")
              }}</md-table-cell>
              <md-table-cell md-label="Tätigkeit" md-string>{{
                item.Title
              }}</md-table-cell>
              <md-table-cell md-label="Jugendmannschaft" md-string>{{
                item.Team
              }}</md-table-cell>
              <md-table-cell md-label="Verantwortlich" md-string>{{
                item.Responsible ? "ja" : "nein"
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
        <div v-else>
          <font color="red">
            <h2>Bitte einen Trainer eingeben!</h2>
          </font>
        </div>
        <md-snackbar :md-active.sync="showSnackbar" :md-duration="2000">
          <span>{{ snackBarText }}</span>
        </md-snackbar>
      </md-app-content>
      <md-app-content v-if="versionMode">
        <h2>Version 1.1.0</h2>
        Copyright &copy; 2019-2023<br />
        Autor: Frank Hablizel
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "Training",
  props: {
    msg: String,
  },
  data: function () {
    return {
      url : "https://tsv1848.ddnss.org/api/training/",
      // url: "http://127.0.0.1:50000/api/training/",
      showSnackbar: false,
      snackBarText: "???",
      coach: localStorage.getItem("coach"),
      team: localStorage.getItem("team"),
      titel: "Training",
      responsible: localStorage.getItem("responsible"),
      date: new Date(),
      pin: "",
      coachMode: true,
      historyMode: false,
      versionMode: false,
      trainingItems: [],
      m: moment.moment,
    };
  },
  computed: {
    // Calculate state of responsible checkbox
    isResponsibleDisabed() {
      return this.titel === "Schiedsrichter";
    },

    isSendEnabled() {
      return (
        this.pin.length != 0 &&
        this.coach.length != 0 &&
        this.date != null &&
        this.team != null &&
        this.date != null
      );
    },
  },
  methods: {
    handleSend() {
      try {
        var responsible = this.responsible == 1 ? "true" : "false";
        var sendDate = new Date();
        var data =
          '{"Coach": "' +
          this.coach +
          '","Team": "' +
          this.team +
          '","Responsible":' +
          responsible +
          ',"Date":"' +
          this.date.toISOString() +
          '","Pin":"' +
          this.pin +
          '","SendDate":"' +
          sendDate.toISOString() +
          '","Title":"' +
          this.titel +
          '"}';
        var msg = String(data);
        axios
          .post(this.url, msg)
          // eslint-disable-next-line
          .then((response) => {
            this.snackBarText = "Daten erfolgreich übermittelt";
            this.showSnackbar = true;
            localStorage.setItem("coach", this.coach);
            localStorage.setItem("team", this.team);
            localStorage.setItem("responsible", this.responsible);
          })
          .catch((e) => {
            if (e.response.status == 401) {
              this.snackBarText =
                "Ungültiger Benutzer oder falsches Passwort. Bitte Groß/Kleinschreibung beachten!";
            } else if (e.response.status == 406) {
              this.snackBarText =
                "Daten unvollständig! Bitte prüfen, ob z.B. die PIN eingegeben wurde.";
            } else {
              this.snackBarText =
                "Fehler " + JSON.stringify(e.response.status) + " aufgetreten!";
            }
            this.showSnackbar = true;
          });
      } catch (e) {
        this.snackBarText = "Fehler " + String(e) + " aufgetreten!";
        this.showSnackbar = true;
      }
    },

    handleCoach() {
      this.coachMode = true;
      this.historyMode = false;
      this.versionMode = false;
    },

    handleVersion() {
      this.coachMode = false;
      this.historyMode = false;
      this.versionMode = true;
    },

    // Query history of training units of the current trainer
    handleHistory() {
      this.coachMode = false;
      this.historyMode = true;
      this.versionMode = false;

      this.m = moment;
      moment.locale("de");

      if (this.coach != "") {
        var query =
          this.url +
          "?trainer=" +
          this.coach +
          "&pin=" +
          this.pin +
          "&last=5" +
          "&title=" +
          this.titel;
        try {
          axios
            .get(query)
            .then((response) => {
              this.trainingItems = JSON.parse(JSON.stringify(response.data));
              this.snackBarText = "Daten wurden aktualisiert.";
              this.showSnackbar = true;
            })
            .catch((e) => {
              alert("Fehler: " + String(e));
            });
        } catch (e) {
          alert("Fehler: " + String(e));
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  border: 0px solid red !important;
}
md-table-row {
  margin: 0;
  padding: 0;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 0px;
}
a {
  color: #42b983;
  margin: 0;
  padding: 0;
}
</style>
